/**
 * 区域设置实体
 * zxw
 * 2024-08-15
 */
import React, { Component } from 'react';
import { Modal, Input,Row,Col, Button,
    message, Avatar, Radio, } from 'antd';
import {
    SkinOutlined, 
} from '@ant-design/icons';
import $ from 'jquery';
import { AddRequestHeaders } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

const MODULENAME = '区域';

const { TextArea } = Input;

class Entity extends Component{
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            ulid: '',
            name: '',
            adcode: '',
            parentAdcode: '',
            longitude: '',
            latitude: '',
            openPosition: 0,
            themeNumber: CNF.themes[0].number,
            dashboardName: '交通设备综合信息管理大屏',
            description: '',
        }
    }
    changeName = (e) =>{this.setState({name: e.target.value});}
    changeAdcode = (e) =>{this.setState({adcode: e.target.value});}
    changeParentAdcode = (e) =>{this.setState({parentAdcode: e.target.value});}
    changeLongitude = (e) =>{this.setState({longitude: e.target.value});}
    changeLatitude = (e) =>{this.setState({latitude: e.target.value});}
    changeOpenPosition = (e) =>{this.setState({openPosition: e.target.value});}
    changeThemeNumber = (value) =>{this.setState({themeNumber: value});}
    changeDashboardName = (e) =>{this.setState({dashboardName: e.target.value});}
    changeDescription = (e) =>{this.setState({description: e.target.value});}

    create = () =>{
        const _this = this;

        //  执行创建
        $.ajax({
            url: `${CNF.api}setting/areas`,
            headers: AddRequestHeaders(),
            type: 'POST',
            dataType: 'JSON',
            data:JSON.stringify({
                'name': this.state.name,
                'adcode': this.state.adcode,
                'parent_adcode': this.state.parentAdcode,
                'longitude': this.state.longitude,
                'latitude': this.state.latitude,
                'open_position': this.state.openPosition,
                'theme_number': this.state.themeNumber,
                'dashboard_name': this.state.dashboardName,
                'description': this.state.description,
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                    setTimeout(function(){
                        _this.handleCancel();
                        _this.props.isRefresh();
                    }, 1500);
                }else{
                    message.error(data.msg, 1.5);
                    _this.setState({loading: false});
                }
            }
        });
    };

    update = () =>{
        const _this = this;

        //  执行更新
        $.ajax({
            url: `${CNF.api}setting/areas/${this.state.ulid}`,
            headers: AddRequestHeaders(),
            type: 'PUT',
            dataType: 'JSON',
            data:JSON.stringify({
                'action': 'UPDATE',
                'name': this.state.name,
                'adcode': this.state.adcode,
                'parent_adcode': this.state.parentAdcode,
                'longitude': this.state.longitude,
                'latitude': this.state.latitude,
                'open_position': this.state.openPosition,
                'theme_number': this.state.themeNumber,
                'dashboard_name': this.state.dashboardName,
                'description': this.state.description,
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                    setTimeout(function(){
                        _this.handleCancel();
                        _this.props.isRefresh();
                    }, 1500);
                }else{
                    message.error(data.msg, 1.5);
                    _this.setState({loading: false});
                }
            }
        });
    };

    handleOk = () =>{
        //  参数校验
        //  区域名称
        if(this.state.name === ''){
            message.error('区域名称不能为空！');
            return;
        }
        // 行政代码
        let regex = /^([0-9]{4,8})$/;
        if(!regex.test(this.state.adcode)){
            message.error('行政代码格式错误！');
            return;
        }
        // 父级代码
        if(!regex.test(this.state.adcode)){
            message.error('父级代码格式错误！');
            return;
        }

        this.setState({loading: true});
        if (this.props.record){
            this.update();
        }else{
            this.create();
        }
    };
    
    handleCancel = () =>{
        this.props.setIsModalOpen(false);
        this.setState({
            loading: false,
            ulid: '',
            name: '',
            adcode: '',
            parentAdcode: '',
            longitude: '',
            latitude: '',
            openPosition: 0,
            themeNumber: CNF.themes[0].number,
            dashboardName: '交通设备综合信息管理大屏',
            description: '',
        });
    };

    componentDidUpdate(){
        if (this.props.record && this.state.ulid !== this.props.record.key){
            this.setState({
                record: this.props.record,
                ulid: this.props.record.key,
                name: this.props.record.name,
                adcode: this.props.record.adcode,
                parentAdcode: this.props.record.parent_adcode,
                longitude: this.props.record.longitude,
                latitude: this.props.record.latitude,
                openPosition: this.props.record.open_position,
                themeNumber: this.props.record.theme_number,
                dashboardName: this.props.record.dashboard_name,
                description: this.props.record.description,
            });
        }
    }
  
    render() {
        return (
            <div>
                <Modal
                    width={600}
                    title={(this.props.record?'修改':'创建') + MODULENAME}
                    open={this.props.isModalOpen}
                    onCancel={this.handleCancel}
                    keyboard={true}
                    okText='确认'
                    cancelText='取消'
                    footer={[
                        <Button key="cancel" disabled={this.state.loading} onClick={this.handleCancel}>取消</Button>,
                        <Button key="ok" type="primary" disabled={this.state.loading} onClick={this.handleOk}>确定</Button>,
                      ]}
                    // style={{ top: 0 }}
                    okButtonProps={{ disabled: this.state.loading }}
                >
                    <Row style={{ marginTop: 5, lineHeight: 2.2 }}>
                        <Col span={5}>区域名称：</Col>
                        <Col span={19}>
                            <Input
                                onChange={this.changeName}
                                placeholder='必填字段'
                                value={this.state.name}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5, lineHeight: 2.2 }}>
                        <Col span={5}>大屏名称：</Col>
                        <Col span={19}>
                            <Input
                                onChange={this.changeDashboardName}
                                value={this.state.dashboardName}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={5} style={{ lineHeight: 2.2 }}>行政代码：</Col>
                        <Col span={6}>
                            <Input
                                onChange={this.changeAdcode}
                                placeholder='必填字段'
                                value={this.state.adcode}
                                disabled={this.props.record?true:this.state.loading}
                            />
                        </Col>
                        <Col span={5} offset={2}>父级代码：</Col>
                        <Col span={6}>
                            <Input
                                onChange={this.changeParentAdcode}
                                value={this.state.parentAdcode}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={5} style={{ lineHeight: 2.2 }}>经度：</Col>
                        <Col span={6}>
                            <Input
                                onChange={this.changeLongitude}
                                value={this.state.longitude}
                                disabled={this.state.loading}
                            />
                        </Col>
                        <Col span={5} offset={2}>纬度：</Col>
                        <Col span={6}>
                            <Input
                                onChange={this.changeLatitude}
                                value={this.state.latitude}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={5} style={{ lineHeight: 2.2 }}>开启定位：</Col>
                        <Col span={6}>
                        <Radio.Group onChange={this.changeOpenPosition} value={this.state.openPosition}>
                            <Radio value={1}>是</Radio>
                            <Radio value={0}>否</Radio>
                        </Radio.Group>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={5} style={{ lineHeight: 2.2 }}>主题样式：</Col>
                        <Col span={3}>
                            <Avatar 
                                shape='square'
                                icon={this.state.themeNumber===CNF.themes[0].number?<SkinOutlined style={{ color: '#FF904D' }} />:''}
                                style={{ backgroundColor: CNF.themes[0].tbgColor, width: '95%', marginRight: '5%',cursor: 'pointer' }} 
                                onClick={()=>{
                                    this.changeThemeNumber(CNF.themes[0].number);
                                }}
                            />
                        </Col>
                        <Col span={3}>
                            <Avatar shape='square'
                                icon={this.state.themeNumber===CNF.themes[1].number?<SkinOutlined style={{ color: '#FF904D' }} />:''}
                                style={{ backgroundColor: CNF.themes[1].tbgColor, width: '95%', marginLeft: '5%',cursor: 'pointer' }}
                                onClick={()=>{
                                    this.changeThemeNumber(CNF.themes[1].number);
                                }}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5 }}>
                        <Col span={5} style={{ lineHeight: 2.2 }}>备注：</Col>
                        <Col span={19}>
                            <TextArea
                                placeholder='备注可写在这里...'
                                autoSize={{ minRows: 2, maxRows: 4 }}
                                onChange={this.changeDescription}
                                disabled={this.state.loading}
                                value={this.state.description}
                            />
                        </Col>
                    </Row>
                </Modal>
            </div>
        );
    }
}

export default Entity